import BackendConnector from './backendConnector';

export default class UnsubscribeHTTPService {
    static unsubscribe({
        talentId, unsubscription, positionApprovalUuid, messageUuid,
    }) {
        return BackendConnector.post('/public/unsubscribe', {
            talentId, unsubscription, positionApprovalUuid, messageUuid,
        });
    }
}
